// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import CeparioProduction from "../views/CeparioProduction.vue";

export default [
  {
    path: "/cepario-production",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Cepario de trabajo",
        component: CeparioProduction,
        meta: {
          title: "Cepario de trabajo",
        },
      },
    ],
  },
];
